import styled from 'styled-components'

import { device } from 'components/draw/constants'
import PanelWithTitle from 'components/core/PanelWithTitle'

import GooPlaceholderEquation from './GooPlaceholderEquation'

const NoGobblersImg = styled.img`
  margin-bottom: 64px;
  height: 360px;
  margin: 84px 0;
  margin-right: 64px;

  @media ${device.laptopMax} {
    margin: 32px 0;
    height: 280px;
    object-fit: contain;
  }
`

const NoGobblersTitle = styled.div`
  font-weight: 700;
  font-size: 48px;
  @media ${device.laptopMax} {
    font-size: 32px;
    text-align: center;
  }
`

const NoPagesImg = styled(NoGobblersImg)`
  height: 324px;
  margin-top: 72px;
  @media ${device.laptopMax} {
    height: 240px;
  }
`

const NoPagesTitle = styled(NoGobblersTitle)`
  margin-right: 128px;
  @media ${device.laptopMax} {
    margin-right: 0;
  }
`

export default function NoGobblersView({
  panelTitle = 'Empty Factory',
  containerStyle,
}: {
  containerStyle?: React.CSSProperties
  panelTitle?: string
}) {
  return (
    <PanelWithTitle
      title={panelTitle}
      containerStyle={containerStyle}
      contentStyle={{ backgroundColor: '#080a0c', minHeight: 532 }}
    >
      <NoGobblersImg alt="No Gobblers?" src="/images/factory/no_gobblers_gobbler.png" />
      <div>
        <NoGobblersTitle>
          You don&apos;t have any
          <br />
          Gobblers, yet
        </NoGobblersTitle>
        <GooPlaceholderEquation />
      </div>
    </PanelWithTitle>
  )
}

export function NoPagesView() {
  return (
    <PanelWithTitle
      title="No Pages"
      containerStyle={{ margin: 0, marginTop: 24, width: '100%' }}
      contentStyle={{ backgroundColor: '#080a0c', paddingBottom: 24, minHeight: 532 }}
    >
      <NoPagesImg alt="No Pages?" src="/images/factory/no_gobblers_page.png" />
      <div>
        <NoPagesTitle>
          You don&apos;t have any
          <br />
          pages, yet
        </NoPagesTitle>
      </div>
    </PanelWithTitle>
  )
}
